import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Row,
  Col,
  Form,
  Input,
  Select,
  Divider,
  Radio,
  Spin,
  Button,
  message
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import {
  formatDigits,
  getDecryptID,
  isEmailValid,
  loadData,
  notAllowMsgCheck,
  setCommonConfigs
} from '../../../appRedux/actions'
import { GENERAL_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { SKULabelPrintFormat } from '../../../constants/SKULabelPrintFormat'
import { skuGeneration } from '../../../constants/SKUGenerations'
// import { REACT_APP_BUS_SITE_SECOND } from '../../../constants/StoreSetting'
import { env } from '../../../env'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const { REACT_APP_BUS_SITE_SECOND } = env

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const userSwitchSetting = [
  {
    id: '1',
    label: 'Required password when switching usser'
  },
  {
    id: '2',
    label: "Don't required password when switching user"
  }
]

const displayPrices = [
  {
    id: 'False', // ref to tax exclusive entity
    label: 'Tax inclusive'
  },
  {
    id: 'True',
    label: 'Tax exclusive'
  }
]

const barCodeSettings = [
  {
    id: '1',
    label: 'Only allow SKUs',
    isDisable: false
  },
  {
    id: '2',
    label: 'Allow barcode with embedded weight',
    isDisable: true
  },
  {
    id: '3',
    label: 'Allow barcode with embedded price',
    isDisable: true
  }
]

const General = () => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const history = useHistory()

  const loadDataRedux = useSelector(({ settings }) => settings.loadData)
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [countryData, setCountryData] = useState([])
  const [confirmLoading, setConfirmLoading] = useState(true) // change state
  const [addAutoCustomer, setAddAutoCustomer] = useState('0')
  const [showSaleTracks, setShowSaleTracks] = useState('0')
  const [enableTaxCode, setEnableTaxCode] = useState('0')
  const [singleCartScreen, setSingleCartScreen] = useState('0')
  const [isGenerationSeqVisible, setIsGenerationSeqVisible] = useState(true)
  const [getPrinters, setPrinters] = useState([{ id: 0, name: 'Default' }])
  const [getIsDisable, setIsDisable] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [screenListingInformation, setScreenListingInformation] = useState({
    basicInformation: {},
    basicAddress: {},
    storeName: '',
    url: '',
    defaultCurrency: 0,
    timeZone: 0,
    printFormat: 0,
    skuGeneration: 0,
    sellScreenBarCode: 0,
    userSwitchSecurity: 0,
    skuGenerationSeq: '',
    currencyType: [{}],
    timeZones: [{}],
    taxExclusive: 'False',
    taxes: '1',
    printers: 0
  })
  const [taxData, setTaxData] = useState([])
  const [showTax, setShowTax] = useState(false)

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE || a == UPDATE).length > 0) {
        setIsDisable(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  useEffect(() => {
    dispatch(setCommonConfigs(GENERAL_SCREEN))
    getCountriesService()
    getAllTaxes()
  }, [])

  useEffect(() => {
    setConfirmLoading(true)
    getAllConfigurationsService()
  }, [loadDataRedux])

  const initialValues = {
    SkuGeneration: '1',
    SellScreenBarcode: '1'
  }

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      form.setFieldsValue(initialValues)
    }
    return () => (mounted = false)
  }, [form, initialValues])
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      handleChangeCurSeqNum(true)
    }

    return () => (mounted = false)
  }, [])

  async function getCountriesService () {
    setConfirmLoading(true)
    await ds
      .getCountries()
      .then(res => {
        // dispatch(loadData(false));
        setConfirmLoading(false)
        setCountryData(res)
      })
      .catch(error => {
        setConfirmLoading(false)
      })
  }

  async function getAllConfigurationsService () {
    setConfirmLoading(true)
    await ds
      .getGeneralScreenList('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res) {
          setConfirmLoading(false)
          if (res.printers && res.printers.length > 0) {
            const printList = [{ id: 0, name: 'Default' }]
            res.printers.map(zzx => {
              printList.push({
                id: zzx.printerID,
                name: zzx.name
              })
            })
            setPrinters(printList)
          }
          setAddAutoCustomer(
            res.automaticallyAddCustomer &&
              res.automaticallyAddCustomer == 'True'
              ? '1'
              : '0'
          )
          setShowSaleTracks(
            res.showSaleTracks && res.showSaleTracks == 'True' ? '1' : '0'
          )
          setSingleCartScreen(
            res.singleCartScreen && res.singleCartScreen == 'True' ? '1' : '0'
          )
          setEnableTaxCode(
            res.enableTaxCodeOnReceipt && res.enableTaxCodeOnReceipt == 'True'
              ? '1'
              : '0'
          )
          if (res.taxExclusive && res.taxExclusive.includes('alse')) {
            setShowTax(true)
          } else {
            setShowTax(false)
          }
          setScreenListingInformation({
            basicInformation: res.basicInformation,
            basicAddress: res.basicAddress,
            storeName: res.storeName,
            url: res.url,
            defaultCurrency: res.defaultCurrency,
            printFormat: res.printFormat,
            skuGeneration: res.skuGeneration,
            sellScreenBarCode: res.sellScreenBarCode,
            userSwitchSecurity: res.userSwitchSecurity,
            skuGenerationSeq: res.currentSequenceNumber,
            basicInformation: res.basicInformation,
            basicAddress: res.basicAddress,
            currencyType: res.currencyType,
            timeZones: res.timeZones,
            taxExclusive: res.taxExclusive,
            taxes: res.incTaxID,
            printers: res.selPrinter ? parseInt(res.selPrinter) : 0
          })
        } else {
          message.error('Something went wrong...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  async function getAllTaxes () {
    await ds
      .getTaxList('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        if (res && res.length > 0) {
          let array = res.map(e => {
            return {
              id: getDecryptID(e.salesTaxSId),
              salesTaxValue: e.salesTaxValue
                ? formatDigits(e.salesTaxValue, getDecimalPlaces)
                : '0.00',
              salesTaxName: e.salesTaxName,
              isFix: e.isFix ? e.isFix : false,
              isGroup: e.isGroup ? e.isGroup : false
            }
          })
          setTaxData(array)
        } else {
          setTaxData([])
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        // setConfirmLoading(false);
      })
  }

  useEffect(() => {
    // setConfirmLoading(true);
    setupFormValues()
  }, [screenListingInformation])

  const setupFormValues = () => {
    if (screenListingInformation) {
      form.setFieldsValue({
        taxes: screenListingInformation.taxes
          ? screenListingInformation.taxes
          : '1',
        StoreName: screenListingInformation.storeName,
        LabelPrinterFormat: screenListingInformation.printFormat,
        SkuGeneration: screenListingInformation.skuGeneration,
        SellScreenBarcode: screenListingInformation.sellScreenBarCode,
        UserSwitchSetting: screenListingInformation.userSwitchSecurity,
        TaxExclusive: screenListingInformation.taxExclusive,
        Country:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.country
            ? parseInt(screenListingInformation.basicAddress.country)
            : '',
        PCountry:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.pCountry &&
          screenListingInformation.basicAddress.pCountry != '0'
            ? parseInt(screenListingInformation.basicAddress.pCountry)
            : '',
        City:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.city
            ? screenListingInformation.basicAddress.city
            : '',
        PCity:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.pCity
            ? screenListingInformation.basicAddress.pCity
            : '',
        State:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.state
            ? screenListingInformation.basicAddress.state
            : '',
        PState:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.pState
            ? screenListingInformation.basicAddress.pState
            : '',
        PostCode:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.postCode
            ? screenListingInformation.basicAddress.postCode
            : '',
        PPostCode:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.pPostCode
            ? screenListingInformation.basicAddress.pPostCode
            : '',
        SubRub:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.subRub
            ? screenListingInformation.basicAddress.subRub
            : '',
        PSubRub:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.pSubRub
            ? screenListingInformation.basicAddress.pSubRub
            : '',
        Twitter:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.twitter
            ? screenListingInformation.basicInformation.twitter
            : '',
        Email:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.email
            ? screenListingInformation.basicInformation.email
            : '',
        Website:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.webSite
            ? screenListingInformation.basicInformation.webSite
            : '',
        Phone:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.phone
            ? screenListingInformation.basicInformation.phone
            : '',
        PhysicalAddress:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.streetSplit &&
          screenListingInformation.basicAddress.streetSplit.length > 0
            ? screenListingInformation.basicAddress.streetSplit[0]
            : '',
        PhysicalAddress2:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.streetSplit &&
          screenListingInformation.basicAddress.streetSplit.length > 0
            ? screenListingInformation.basicAddress.streetSplit[1]
            : '',
        PostalAddress:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.streetSplit &&
          screenListingInformation.basicAddress.pStreetSplit.length > 0
            ? screenListingInformation.basicAddress.pStreetSplit[0]
            : '',
        PostalAddress2:
          screenListingInformation.basicAddress &&
          screenListingInformation.basicAddress.streetSplit &&
          screenListingInformation.basicAddress.pStreetSplit.length > 0
            ? screenListingInformation.basicAddress.pStreetSplit[1]
            : '',
        ContactNameFirst:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.contactNameSplit &&
          screenListingInformation.basicInformation.contactNameSplit.length > 0
            ? screenListingInformation.basicInformation.contactNameSplit[0]
            : '',
        ContactNameLast:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.contactNameSplit &&
          screenListingInformation.basicInformation.contactNameSplit.length > 0
            ? screenListingInformation.basicInformation.contactNameSplit[1]
            : '',
        CurrentSeqNumber: screenListingInformation.skuGenerationSeq,
        DefaultCurrency: screenListingInformation.defaultCurrency,
        TimeZone:
          screenListingInformation.basicInformation &&
          screenListingInformation.basicInformation.timeZoneId
            ? screenListingInformation.basicInformation.timeZoneId
            : '',
        printers: screenListingInformation.printers
      })
      if (form.getFieldValue('StoreName')) {
        setConfirmLoading(false)
      }
      if (screenListingInformation.skuGeneration == '1') {
        setIsGenerationSeqVisible(true)
      }
    }
  }

  async function UpdateBasicInfoService (values) {
    await ds
      .updateStoreBasicInfo(
        {
          ContactName: values.ContactNameFirst + '$' + values.ContactNameLast,
          WebSite: values.Website,
          Email: values.Email,
          Twitter: values.Twitter,
          Phone: values.Phone
          // asd: values.TimeZone
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(res => {
        //message.success("Data updated successfully");
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  async function UpdateAddressInfoService (values) {
    await ds
      .updateStoreAddressInfo(
        {
          StreetAddress: values.PhysicalAddress + '$' + values.PhysicalAddress2,
          SubRub: values.SubRub,
          City: values.City,
          PostCode: values.PostCode,
          State: values.State,
          Country: values.Country.toString(),
          PStreet: values.PostalAddress + '$' + values.PostalAddress2,
          PSubRub: values.PSubRub,
          PCity: values.PCity,
          PPostCode: values.PPostCode,
          PState: values.PState,
          PCountry: values.PCountry.toString()
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(res => {})
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  async function UpdateGeneralInfoService (values) {
    await ds
      .updateStoreGeneralConfig(
        {
          StoreName: values.StoreName,
          TimeZoneID: values.TimeZone ? values.TimeZone : 0,
          LabelPrintFormat: values.LabelPrinterFormat,
          SKUGeneration: values.SkuGeneration,
          CurrentSequenceNumber: values.CurrentSeqNumber,
          SellScreenBarCode: values.SellScreenBarcode,
          UserSwitching: values.UserSwitchSetting,
          TaxExclusive: values.TaxExclusive,
          AutomaticallyAddCustomerFromReceipt: addAutoCustomer,
          ShowSaleTracks: showSaleTracks == '1' ? 'True' : 'False',
          EnableTaxCodeOnReceipt: enableTaxCode == '1' ? 'True' : 'False',
          CurrencyTypeID: values.DefaultCurrency,
          TaxID: showTax ? values.taxes : '',
          Printer: values && values.printers ? `${values.printers}` : '0',
          SingleScreenForCart: singleCartScreen == '1' ? 'True' : 'False'
        },
        BEHAVIOUR_TYPE.UPDATE
      )
      .then(res => {
        setConfirmLoading(false)
        if (res) {
          message.success('Saved Successfully')
          dispatch(loadData(true))
        } else {
          message.error('Something went wrong...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
  }

  const onFinish = values => {
    setConfirmLoading(true)
    UpdateBasicInfoService(values)
    UpdateAddressInfoService(values)
    UpdateGeneralInfoService(values)
  }

  const onFinishFailed = errorInfo => {
    setConfirmLoading(false)
    message.warn('Kindly Attend to Missing Fields')
  }

  function OnChangeAddAutoCustomer (e) {
    setAddAutoCustomer(e.target.value)
  }

  function OnChangeShowSaleTracks (e) {
    setShowSaleTracks(e.target.value)
  }

  function OnChangeEnableTaxCode (e) {
    setEnableTaxCode(e.target.value)
  }

  function OnChangeSingleCartScreen (e) {
    setSingleCartScreen(e.target.value)
  }

  const handleChangeCurSeqNum = (isDefault = false) => {
    let numericSKUValue = parseInt(form.getFieldValue('CurrentSeqNumber'))
    const getMaxNum = ds.getMaxNumericSKU()
    getMaxNum
      .then(response => {
        if (response) {
          if (response != 0) {
            if (isDefault) {
              form.setFieldsValue({ CurrentSeqNumber: response.toString() })
            } else {
              if (numericSKUValue < response) {
                form.setFieldsValue({ CurrentSeqNumber: response.toString() })
              }
            }
          }
        }
      })
      .catch(e => {})
  }

  function handleKeyPress (e) {
    const keyCode = e.which || e.keyCode
    if (keyCode < 48 || keyCode > 57) {
      e.preventDefault()
    }
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={confirmLoading}
      size='large'
    >
      <>
        <div className='Content-wrapper GeneralSetup-pg'>
          <Row className='mb-3 GeneralSetup-header'>
            <Col lg={24} md={24} sm={24} xs={24}>
              <h1 className='mb-0'>
                <IntlMessages id='setup.general.Title' />
              </h1>
            </Col>
          </Row>

          <div className='mt-5 GeneralSetup-form'>
            <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mt-4'>
              {' '}
              <IntlMessages id='setup.general.subTitle1' />:{' '}
            </h2>

            <Form
              {...formItemLayout}
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className=''
              scrollToFirstError
              id='GeneralSetupForm'
              name='GeneralSetupForm'
              initialValues={initialValues}
            >
              <Row className='StoreSettings-div'>
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'StoreName'}
                    label={<IntlMessages id='setup.general.InputLabel1' />}
                    rules={[
                      {
                        required: true,
                        message: 'Required'
                      }
                    ]}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'LabelPrinterFormat'}
                    label={<IntlMessages id='setup.general.InputLabel2' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel2' />
                      }
                      disabled={getIsDisable}
                    >
                      {SKULabelPrintFormat &&
                        SKULabelPrintFormat.filter(x => x.IsActive == true).map(
                          (e, key) => {
                            return (
                              <option value={e.id.toString()}>
                                {e.labelName}
                              </option>
                            )
                          }
                        )}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='url'
                    label={<IntlMessages id='setup.general.InputLabel3' />}
                  >
                    <div className='Url-store'>
                      <i className={`icon icon-tag text-orange`}></i>
                      <strong>
                        {screenListingInformation.url}
                        {REACT_APP_BUS_SITE_SECOND}
                      </strong>
                    </div>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'SkuGeneration'}
                    label={<IntlMessages id='setup.general.InputLabel4' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel4' />
                      }
                      onChange={e => {
                        if (e == '1') {
                          setIsGenerationSeqVisible(true)
                        } else {
                          setIsGenerationSeqVisible(false)
                        }
                      }}
                      disabled={getIsDisable}
                    >
                      {skuGeneration &&
                        skuGeneration.map((e, key) => {
                          return (
                            <option disabled={e.isDisable} value={e.id}>
                              {e.label}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'DefaultCurrency'}
                    label={<IntlMessages id='setup.general.InputLabel5' />}
                  >
                    <Select
                      showSearch
                      optionFilterProp='children'
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel5' />
                      }
                      disabled={getIsDisable}
                    >
                      {screenListingInformation.currencyType &&
                        screenListingInformation.currencyType.map((e, key) => {
                          return <option value={e.id}>{e.label}</option>
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  {isGenerationSeqVisible ? (
                    <Form.Item
                      className='row-col-100'
                      name='CurrentSeqNumber'
                      label={<IntlMessages id='setup.general.InputLabel6' />}
                      onBlur={e => {
                        handleChangeCurSeqNum(false)
                      }}
                    >
                      <Input
                        onKeyPress={handleKeyPress}
                        disabled={getIsDisable}
                        size='large'
                      />
                    </Form.Item>
                  ) : (
                    ''
                  )}
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'TimeZone'}
                    label={<IntlMessages id='setup.general.InputLabel7' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel7' />
                      }
                      showSearch
                      optionFilterProp='children'
                      disabled={getIsDisable}
                    >
                      {screenListingInformation.timeZones &&
                        screenListingInformation.timeZones.map((e, key) => {
                          return (
                            <option key={key} value={e.id}>
                              {e.label}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'SellScreenBarcode'}
                    label={<IntlMessages id='setup.general.InputLabel8' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel8' />
                      }
                      disabled={getIsDisable}
                    >
                      {barCodeSettings &&
                        barCodeSettings.map((e, key) => {
                          return (
                            <option disabled={e.isDisable} value={e.id}>
                              {e.label}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'TaxExclusive'}
                    label={<IntlMessages id='setup.general.taxdisplay' />}
                  >
                    <Select
                      size='large'
                      // placeholder={
                      //   <IntlMessages id="setup.general.InputLabel9" />
                      // }
                      disabled={getIsDisable}
                      onClick={e => {
                        if (
                          e &&
                          e.target &&
                          e.target.innerText &&
                          displayPrices.filter(a => a.id == 'False')[0].label ==
                            e.target.innerText
                        ) {
                          setShowTax(true)
                        } else setShowTax(false)
                      }}
                    >
                      {displayPrices &&
                        displayPrices.map((e, key) => {
                          return (
                            <option key={key} value={e.id}>
                              {e.label}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'UserSwitchSetting'}
                    label={<IntlMessages id='setup.general.InputLabel9' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel9' />
                      }
                      disabled={getIsDisable}
                    >
                      {userSwitchSetting &&
                        userSwitchSetting.map((e, key) => {
                          return (
                            <Select.Option
                              key={key}
                              value={e.id}
                              disabled={e.id == 2 ? true : false}
                            >
                              {e.label}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'printers'}
                    label={<span>Printers</span>}
                  >
                    <Select
                      size='large'
                      placeholder={'Choose Printers'}
                      disabled={getIsDisable}
                    >
                      {getPrinters &&
                        getPrinters.map((e, key) => {
                          return (
                            <Select.Option
                              key={key}
                              value={e.id}
                              // disabled={e.id == 2 ? true : false}
                            >
                              {e.name}
                            </Select.Option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>

                {showTax && (
                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    className='form-inner-pad-0 pr-0-device'
                  >
                    <Form.Item
                      className='row-col-100'
                      name={'taxes'}
                      label={
                        <IntlMessages id='setup.outletsandregisters.col2' />
                      }
                    >
                      <Select
                        size='large'
                        disabled={getIsDisable}
                        showSearch
                        optionFilterProp='children'
                      >
                        {taxData &&
                          taxData.map((e, key) => {
                            return (
                              <option key={key} value={e.id}>
                                {`${e.salesTaxName} (${
                                  e.isGroup ? 'Group Taxes' : e.salesTaxValue
                                }${e.isFix ? ' Fixed' : e.isGroup ? '' : '%'})`}
                              </option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <Row>
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <p className='mb-0 mt-2'>
                    <IntlMessages id='sell.general.showtracksale' />
                  </p>

                  <Radio.Group
                    style={{ display: 'inline-grid' }}
                    size='large'
                    value={showSaleTracks}
                    onChange={OnChangeShowSaleTracks}
                  >
                    <Row>
                      <Radio value={'1'}>
                        <IntlMessages id='Yes' />
                      </Radio>

                      <Radio value={'0'}>
                        <IntlMessages id='No' />
                      </Radio>
                    </Row>
                  </Radio.Group>
                  <p>
                    <IntlMessages id='sell.general.showtracksale.detail' />
                  </p>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <p className='mb-0 mt-2'>
                    {' '}
                    <IntlMessages id='generalconfigs.setup.singlescreen' />{' '}
                  </p>

                  <Radio.Group
                    style={{ display: 'inline-grid' }}
                    size='large'
                    value={singleCartScreen}
                    onChange={OnChangeSingleCartScreen}
                  >
                    <Row>
                      <Radio value={'1'}>
                        <IntlMessages id='Yes' />
                      </Radio>

                      <Radio value={'0'}>
                        <IntlMessages id='No' />
                      </Radio>
                    </Row>
                  </Radio.Group>
                  <p>
                    <IntlMessages id='generalconfigs.setup.singlescreen.desc' />
                  </p>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <p className='mb-0 mt-2'>Enable Tax Code On Receipt</p>

                  <Radio.Group
                    style={{ display: 'inline-grid' }}
                    size='large'
                    value={enableTaxCode}
                    onChange={OnChangeEnableTaxCode}
                  >
                    <Row>
                      <Radio value={'1'}>
                        <IntlMessages id='Yes' />
                      </Radio>

                      <Radio value={'0'}>
                        <IntlMessages id='No' />
                      </Radio>
                    </Row>
                  </Radio.Group>
                  <p>
                    If it is yes then Tax Code will be appear on receipt with
                    items.
                  </p>
                </Col>
              </Row>

              <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mt-4'>
                {' '}
                <IntlMessages id='setup.general.subTitle2' />:{' '}
              </h2>

              <Row className='BasicInformation-div'>
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className={'w-100 row-col-100'}
                    name={'ContactNameFirst'}
                    label={<IntlMessages id='setup.general.InputLabel11' />}
                    rules={[
                      {
                        required: true,
                        message: 'Required'
                      }
                    ]}
                  >
                    <Input
                      className='w-100'
                      placeholder='Enter First Name'
                      size='large'
                      disabled={getIsDisable}
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className={'w-100 row-col-100'}
                    name={'ContactNameLast'}
                    label={<IntlMessages id='general.scree.lastname' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      placeholder=' Enter Last Name'
                      maxLength={30}
                      className='w-100'
                      size='large'
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'Website'}
                    label={<IntlMessages id='setup.general.InputLabel12' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Website'
                      maxLength={200}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'Email'}
                    label={<IntlMessages id='setup.general.InputLabel13' />}
                    rules={[
                      {
                        required: true,
                        message: 'Required'
                      },
                      {
                        validator: isEmailValid
                      }
                    ]}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Email Address'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'Twitter'}
                    label={<IntlMessages id='setup.general.InputLabel14' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Twitter'
                      maxLength={200}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name={'Phone'}
                    label={<IntlMessages id='setup.general.InputLabel15' />}
                    rules={[
                      {
                        pattern: /^[0-9+\-() ]*$/,
                        message: 'Please enter a valid Phone number.'
                      }
                    ]}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Phone number'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mt-4'>
                {' '}
                <IntlMessages id='setup.general.subTitle3' />:{' '}
              </h2>

              <Row className='Address-div'>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <h4 className='mt-2'>
                    <IntlMessages id='setup.general.address.Title1' />
                  </h4>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PhysicalAddress'
                    label={<IntlMessages id='setup.general.InputLabel16' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Street 1'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PhysicalAddress2'
                    label={<IntlMessages id='setup.general.InputLabel17' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Street 2'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='SubRub'
                    label={<IntlMessages id='setup.general.InputLabel18' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Subrub'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='City'
                    label={<IntlMessages id='setup.general.InputLabel19' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter City'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PostCode'
                    label={<IntlMessages id='setup.general.InputLabel20' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Postcode'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='State'
                    label={<IntlMessages id='setup.general.InputLabel21' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter State'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='Country'
                    label={<IntlMessages id='setup.general.InputLabel22' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel22' />
                      }
                      disabled={getIsDisable}
                      showSearch
                      optionFilterProp='children'
                    >
                      {countryData &&
                        countryData.map((e, key) => {
                          return (
                            <option value={e.id} key={key}>
                              {e.label}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <h4 className='mt-2'>
                    <IntlMessages id='setup.general.address.Title2' />{' '}
                  </h4>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PostalAddress'
                    label={<IntlMessages id='setup.general.InputLabel16' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Street 1'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PostalAddress2'
                    label={<IntlMessages id='setup.general.InputLabel17' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Street 2'
                      maxLength={50}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PSubRub'
                    label={<IntlMessages id='setup.general.InputLabel18' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Subrub'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PCity'
                    label={<IntlMessages id='setup.general.InputLabel19' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter City'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PPostCode'
                    label={<IntlMessages id='setup.general.InputLabel20' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter Postcode'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pr-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PState'
                    label={<IntlMessages id='setup.general.InputLabel21' />}
                  >
                    <Input
                      disabled={getIsDisable}
                      size='large'
                      placeholder=' Enter State'
                      maxLength={30}
                    />
                  </Form.Item>
                </Col>

                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='row-col-100'
                    name='PCountry'
                    label={<IntlMessages id='setup.general.InputLabel22' />}
                  >
                    <Select
                      size='large'
                      placeholder={
                        <IntlMessages id='setup.general.InputLabel22' />
                      }
                      disabled={getIsDisable}
                      showSearch
                      optionFilterProp='children'
                    >
                      {countryData &&
                        countryData.map((e, key) => {
                          return (
                            <option value={e.id} key={key}>
                              {e.label ? e.label : ''}
                            </option>
                          )
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <Row className='mt-3'>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className='form-inner-pad-0 text-right'
              >
                <Button
                  className='dk-btn-cancel'
                  type='primary'
                  onClick={() => history.push('/dashboard/main')}
                  size='large'
                >
                  <IntlMessages id='setup.general.cancelBtn' />
                </Button>

                <Button
                  className='dk-btn-add'
                  type='primary'
                  form={'GeneralSetupForm'}
                  htmlType='submit'
                  disabled={getIsDisable}
                  size='large'
                >
                  <IntlMessages id='setup.general.saveBtn' />
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default General
